<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :isFilter="false"
                :title="$t('change_of_grade_admin_detail')"/>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :isFilter="false"
                      :title="$t('change_of_grade_admin_detail')"/>
      </template>
      <div v-if="gradeChangeData.id">
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <h6 class="text-uppercase mb-0">
                {{ toUpperCase('application_information') }}
              </h6>
            </div>
          </div>
          <div class="col-12">
            <b-row>
              <div class="col-12">
                <div class="border rounded p-4 mb-3 h-100">
                  <div class="mb-4">
                    <h6 class="text-uppercase mb-0">
                      {{ $t('student_information').toUpper() }}
                    </h6>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('student_id')">
                        <span>{{ gradeChangeData.student_number }}</span>
                    </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('full_name')">
                        <span>{{ gradeChangeData.student_name + ' ' + gradeChangeData.student_surname }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('course_name')">
                        <span>{{ gradeChangeData.course_name }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('letter_grade')">
                        <span>{{ gradeChangeData.letter_grade }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('new_letter_grade')">
                        <span>{{ gradeChangeData.new_letter_grade }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('reason')">
                        <span>{{ gradeChangeData.reason }}</span>
                      </b-form-group>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12 col-xl-6">
                      <b-form-group :label="$t('status')">
                        <span>{{ gradeChangeData.status_name }}</span>
                      </b-form-group>
                    </div>
                  </div>

                </div>
              </div>
            </b-row>
          </div>
        </div>
        <div v-if="selectedActiveStep" class="mt-3">
          <h6 class="text-uppercase mb-4">{{ $t('approval_procedures').toUpper() }}</h6>
          <ValidationObserver ref="updateForm">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <ValidationProvider v-slot="{ valid, errors }" name="status" rules="required">
                  <b-form-group :label="$t('status')">
                    <b-form-select v-model="updateStep.status"
                                   :options="statusOptions"
                                   :state="errors[0] ? false : null"
                    />
                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </div>
          </ValidationObserver>
          <b-form-group>
            <LoadingButton
                :loading="isLoading"
                :text="$t('approve')"
                @click="stepUpdate"/>
          </b-form-group>
        </div>
        <div v-if="steps && steps.length && Object.assign(steps).length" class="mt-3">
          <b-table :empty-text="$t('there_are_no_records')" :fields="[
                            { key: 'rank', label: this.toUpperCase('rank'), thClass: 'text-center', tdClass: 'text-center' },
                            { key: 'name', label: this.toUpperCase('can_approvers'), thClass: 'text-center' },
                            { key: 'approved', label: this.toUpperCase('approved_by'), thClass: 'text-center' },
                            { key: 'status', label: this.toUpperCase('status'), thClass: 'text-center' },
                            { key: 'reason', label: this.toUpperCase('explanation'), thClass: 'text-center' },
                            { key: 'updated_at', label: this.toUpperCase('updated_at'), thClass: 'text-center' }
                        ]" :items="steps" bordered class="mb-3 table-dropdown no-scrollbar border rounded"
                   responsive show-empty sort-by="rank" striped>
            <template #cell(approved)="data">
                            <span v-for="(approver, key) in data.item.approved" :key="key">
                                {{ approver.name }} {{ approver.surname }}<br>
                            </span>
            </template>
            <template #cell(status)="data">
              {{ data.item.status_name }}
            </template>
          </b-table>
        </div>
      </div>
    </app-layout>
  </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

import {ValidationProvider, ValidationObserver} from "vee-validate"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import LoadingButton from "@/components/elements/LoadingButton.vue";
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";
import GradeChangeService from "@/services/GradeChangeService";

export default {
  components: {
    YesNoSelectbox,
    LoadingButton,
    MultiSelectbox,
    AppLayout,
    Header,
    HeaderMobile,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      form: {},
      updateStep: {
        status: null
      },
      gradeChangeData: {},
      step: {},
      steps: {},
      statuses: {},
      statusOptions: [
        {value: null, text: 'select'},
        {value: 'approved', text: this.$t('approved')},
        {value: 'declined', text: this.$t('declined')},
      ],
      isLoading: false,
    }
  },

  metaInfo() {
    return {
      title: this.$t('change_of_grade_admin_detail')
    }
  },
  computed: {
    userRoles() {
      return this.$store.getters['auth/getActiveRole']
    },
      selectedActiveStep() {
          if (this.steps && this.steps.length > 0) {
              const activeStep = this.steps.find(item => item.active)
              if (!activeStep || !activeStep.approvers || activeStep.approvers.length === 0) {
                  return false
              }
              
              return activeStep.approvers[0].name === this.userRoles
          } else {
              return false
          }
      }
  },
  created() {
    this.getGradeChangeRequest();
  },
  methods: {
    getGradeChangeRequest() {
      GradeChangeService.get(this.$route.params.id)
          .then(response => {
            this.gradeChangeData = response.data.data;
            this.step = this.gradeChangeData.step == null ? {} : this.gradeChangeData.step;
            this.steps = this.gradeChangeData.steps;
          })
          .catch(e => {
            this.$toast.error(e.data.message)
          })

    },
    async update() {
      const isValid = await this.$refs.formObserver.validate();
      if (isValid) {
        this.$swal.fire({
          title: this.$t('warning'),
          text: this.$t('leave_of_absence_statement'),
          showCancelButton: true,
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
        }).then((result) => {
          this.isLoading = true
          if (result.isConfirmed) {
            this.gradeChangeData.attended_all_classes_after_prev_time_off = this.gradeChangeData.attended_all_classes_after_prev_time_off === 'Yes' ? 1 : 0
            this.gradeChangeData.good_standing = this.gradeChangeData.good_standing === 'Yes' ? 1 : 0
            this.gradeChangeData.on_probation = this.gradeChangeData.on_probation === 'Yes' ? 1 : 0
            GradeChangeService.updateStep(this.$route.params.id, this.gradeChangeData)
                .then(response => {
                  this.$toast.success(this.$t('api.' + response.data.message));
                  this.getGradeChangeRequest()
                })
                .catch(error => {
                  this.showErrors(error, this.$refs.formObserver)
                }).finally(this.isLoading = false);
          }
        })
      }
    },
    async stepUpdate() {
      const isValid = await this.$refs.updateForm.validate();
      if (isValid) {
        this.$swal.fire({
          title: this.$t('warning'),
          text: this.$t('leave_of_absence_statement'),
          showCancelButton: true,
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no'),
        }).then((result) => {
          this.isLoading = true
          if (result.isConfirmed) {
            const data = {
              status: this.updateStep.status,
            }
            const activeStep = this.steps.filter((item) => item.active)
            GradeChangeService.updateStep(activeStep[0].id, data)
                .then(response => {
                  this.$toast.success(this.$t('api.' + response.data.message));
                  this.getGradeChangeRequest()
                })
                .catch(error => {
                  this.showErrors(error, this.$refs.formObserver)
                }).finally(this.isLoading = false);
          }
        })
      }
    }

  },
};
</script>
